import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { UploadReqJobProfileModalComponent } from 'src/app/pages/mission-control-page/upload-req-page/upload-req-job-profile-modal/upload-req-job-profile-modal.component';

@Injectable({
  providedIn: 'root'
})
export class UploadReqJobProfileModalService {

  jobProfileModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(jobId: any): void {
    const config = new ModalConfig();
    config.class = 'modal-lg four-dot-five-modal-large';
    config.initialState = { jobId };
    this.jobProfileModal = this.bsModalService.show(UploadReqJobProfileModalComponent, config);
  }
}
